import { Reveal, SectionHead } from "./Reveal";
import { X, Check } from "lucide-react";

const ROWS = [
  ["Premium modern design", true, true],
  ["Mobile-first responsive build", true, true],
  ["WhatsApp enquiry integration", false, true],
  ["Launch measured in hours, not weeks", false, true],
  ["Traditional agency-level pricing", true, false],
  ["Heavy overheads baked into your bill", true, false],
];

export const Compare = () => (
  <section data-testid="compare-section" className="relative overflow-hidden bg-obsidian py-24 md:py-32">
    <div className="pointer-events-none absolute right-[-10%] top-0 h-[40vh] w-[40vw] rounded-full bg-royal/10 blur-[130px]" />
    <div className="relative mx-auto max-w-6xl px-6 md:px-12">
      <SectionHead
        center
        eyebrow="Why pay more?"
        title="Professional website development at around half the typical market price."
        sub="Traditional agencies can charge significantly more for professional website projects. Falkeen Technologies focuses on delivering premium design and practical functionality at a more accessible price point."
      />
      <Reveal delay={0.2}>
        <div className="mx-auto mt-14 max-w-4xl overflow-hidden rounded-2xl border border-white/10">
          <div className="grid grid-cols-[1.6fr_1fr_1fr] border-b border-white/10 bg-charcoal">
            <div className="p-4 md:p-5" />
            <div className="border-l border-white/10 p-4 text-center font-display text-[10px] font-extrabold uppercase tracking-[0.15em] text-zinc-500 md:p-5 md:text-xs">
              Traditional Agency
            </div>
            <div className="border-l border-accent/30 bg-accent/[0.06] p-4 text-center font-display text-[10px] font-extrabold uppercase tracking-[0.15em] text-accent md:p-5 md:text-xs">
              Falkeen Technologies
            </div>
          </div>
          {ROWS.map(([label, agency, falkeen], i) => (
            <div key={label} className={`grid grid-cols-[1.6fr_1fr_1fr] ${i % 2 ? "bg-white/[0.02]" : ""}`} data-testid={`compare-row-${i}`}>
              <div className="p-4 text-xs text-zinc-300 md:p-5 md:text-sm">{label}</div>
              <div className="flex items-center justify-center border-l border-white/10 p-4 md:p-5">
                {agency ? <Check className="h-4 w-4 text-zinc-500" /> : <X className="h-4 w-4 text-zinc-700" />}
              </div>
              <div className="flex items-center justify-center border-l border-accent/20 bg-accent/[0.04] p-4 md:p-5">
                {falkeen ? <Check className="h-4 w-4 text-accent" strokeWidth={2.5} /> : <X className="h-4 w-4 text-zinc-700" />}
              </div>
            </div>
          ))}
        </div>
      </Reveal>
      <Reveal delay={0.3}>
        <p className="mt-10 text-center font-display text-sm font-extrabold uppercase tracking-[0.25em] text-white md:text-base" data-testid="compare-tagline">
          More value. <span className="text-gradient">Less overhead.</span> Better accessibility.
        </p>
      </Reveal>
    </div>
  </section>
);
